module.exports = __webpack_public_path__ + "static/logo-driveshack-4625950cd33e476c46503cec351e3d54.png";